import React from 'react';
import './ModalElement.scoped.scss';

interface ComponentProps {
    content?: JSX.Element;
    closeCallback?: (() => void);
}

interface ComponentState {
    isShowing: boolean;
    isFading: boolean;
    isVisible: boolean;
}

class IntroPanel extends React.Component<ComponentProps, ComponentState> {
    constructor(props: ComponentProps) {
        super(props);
        this.state = { isVisible: false, isShowing: false, isFading: false }
    }

    componentDidUpdate(prevProps: ComponentProps, prevState: ComponentState) {
        if (prevProps.content !== this.props.content) {
            this.setState({ isFading: false, isVisible: true, isShowing: false });
            setTimeout(() => {
                this.setState({ isShowing: true });
            }, 18);
        }
    }

    closeModal = () => {
        if (this.props.closeCallback) {
            this.props.closeCallback();
        }
        this.setState({ isFading: true })
        setTimeout(() => {
            this.setState({ isVisible: false });
        }, 280);
    }

    render() {
        if (this.props.content) {
            return (
                <div className={['modal-outerWrp', this.state.isShowing && this.state.isFading === false ? 'showing' : '', this.state.isVisible ? 'visible' : 'hidden'].join(' ')}>
                    <div className="modal-innerWrp">
                        {this.props.content}
                        <div className="modal-closeIcon-wrp" onClick={this.closeModal}>
                            <img src="/assets/modalCloseIcon.svg" alt="Close modal button" className="modal-closeIcon" />
                        </div>
                    </div>
                    <div className="modal-blurredBG" onClick={this.closeModal}></div>
                </div>
            )
        }
        return <></>
    }
}

export default IntroPanel;